export default __webpack_public_path__ + "static/media/container_tracking-blue.210eaa0c.svg";